import { Clinic, Icd10Code, InsurancePlan, User } from "pwapi";

import { ClinicPhoneDisplay } from "shared/utils/clinicPhoneDisplay";

export const ClinicOption = ({ object: clinic }: { object: Clinic }) => {
  return (
    <div className="SelectSearchInput__option">
      {clinic?.name}
      <>
        {clinic?.external_clinic_id && (
          <strong>
            <code>{clinic?.external_clinic_id}</code>
          </strong>
        )}
        {clinic?.location && (
          <span>
            {clinic.location.street}
            {clinic.location.street2 && `, ${clinic.location.street2}`}
            <br />
            {clinic.location.city}, {clinic.location.state}{" "}
            {clinic.location.zipcode}
          </span>
        )}
        <ClinicPhoneDisplay clinic={clinic} />
      </>
    </div>
  );
};

export const UserOption = ({ object: user }: { object: User }) => {
  return (
    <div className="SelectSearchInput__option">
      {user.first_name} {user.last_name}
      {user.credentials ? `, ${user.credentials}` : ""}
    </div>
  );
};

export const InsurancePlanOption = ({
  object: insurancePlan,
}: {
  object: InsurancePlan;
}) => {
  return (
    <div className="SelectSearchInput__option">
      {insurancePlan.payer_name}
      {insurancePlan.payer_location && (
        <span>
          {insurancePlan.payer_location.street}
          {insurancePlan.payer_location.street2 &&
            `, ${insurancePlan.payer_location.street2}`}
          <br />
          {insurancePlan.payer_location.city},{" "}
          {insurancePlan.payer_location.state}{" "}
          {insurancePlan.payer_location.zipcode}
        </span>
      )}
    </div>
  );
};

export const Icd10Option = ({ object: icd10Code }: { object: Icd10Code }) => {
  return (
    <div className="SelectSearchInput__option">
      {icd10Code.code}
      {icd10Code.description && <span>{icd10Code.description}</span>}
    </div>
  );
};

export const mapClinicsToOptions = (clinics: Clinic[]) => {
  return clinics.map((c) => ({
    value: c.id,
    label: c.name,
    object: c,
  }));
};

export const mapUsersToOptions = (users: User[]) => {
  return users.map((u) => ({
    value: u.id,
    label: `${u.first_name} ${u.last_name}${
      u.credentials ? `, ${u.credentials}` : ""
    }`,
    object: u,
  }));
};

export const mapInsurancePlansToOptions = (insurancePlans: InsurancePlan[]) => {
  return insurancePlans.map((i) => ({
    value: i.id,
    label: i.payer_name,
    object: i,
  }));
};

export const mapIcd10ToOptions = (icd10Codes: Icd10Code[]) => {
  return icd10Codes.map((icd) => ({
    value: icd.id,
    label: icd.code,
    object: icd,
  }));
};
